// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"341":"2069f52e","727":"7ca5190b"}[chunkId] + ".chunk.js");